import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Field, FormikProps } from "formik";
import React from "react";

interface IInputFormField {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  placeholderText?: string;
  formik: FormikProps<any>;
}

export const InputFormField: React.FC<IInputFormField> = ({
  name,
  label,
  formik,
  required = false,
  hidden,
  disabled,
  placeholderText = "",
}) => {
  return (
    <Field name={name}>
      {({ field, form }: any) => (
        <FormControl
          marginBottom="5"
          isInvalid={form.errors[name] && form.touched[name]}
        >
          <FormLabel htmlFor={name} fontWeight="700">
            {label}
            {required && "*"}
          </FormLabel>
          <Input
            {...field}
            onChange={formik.handleChange}
            id={name}
            placeholder={placeholderText}
            disabled={disabled}
            type={hidden ? "hidden" : "text"}
            variant={"filled"}
          />
          <FormErrorMessage>{form.errors[name]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
